(function () {
  var configNode = document.getElementById('chagual-sale-plp-analytics-config');
  var root = document.querySelector('[data-sale-plp-root]');
  if (!configNode || !root) return;

  var config = {};
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (e) {
    config = {};
  }

  var seenViews = new Set();
  var impressionLimit = 8;

  window.dataLayer = window.dataLayer || [];

  function basePayload() {
    return {
      sale_collection_handle: config.collectionHandle || root.getAttribute('data-sale-collection-handle') || '',
      sale_collection_title: config.collectionTitle || root.getAttribute('data-sale-collection-title') || '',
      sale_template: config.template || root.getAttribute('data-sale-template') || '',
      currency: config.currency || ''
    };
  }

  function dispatchDetailEvent(name, detail) {
    if (typeof window.CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
      return;
    }
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, detail || {});
    document.dispatchEvent(evt);
  }

  function pushEvent(name, payload) {
    var eventPayload = Object.assign({
      event: 'chagual_sale_plp',
      sale_plp_event: name
    }, basePayload(), payload || {});

    window.dataLayer.push(eventPayload);
    dispatchDetailEvent('chagual:sale-plp', eventPayload);
  }

  function getCardMeta(card) {
    if (!card) return {};
    var link = card.querySelector('a[data-sale-product-link], a[href*="/products/"]');
    var titleNode = card.querySelector('.chagual-plp-card__title, .title, .hidden-product-link');
    var allCards = Array.prototype.slice.call(document.querySelectorAll('[data-sale-product-card="true"]'));
    var position = allCards.indexOf(card) + 1;
    return {
      product_handle: card.getAttribute('data-product-handle') || '',
      product_title: card.getAttribute('data-product-title') || (titleNode ? titleNode.textContent.trim() : ''),
      product_url: link ? link.getAttribute('href') : '',
      product_position: position > 0 ? position : null,
      card_renderer: card.getAttribute('data-card-renderer') || ''
    };
  }

  function observeViews() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-sale-track-view]').forEach(function (el) {
        var key = el.getAttribute('data-sale-track-view');
        if (!key || seenViews.has(key)) return;
        seenViews.add(key);
        var payload = {};
        if (key === 'proof_strip') payload.surface = 'proof_strip';
        if (key === 'empty_state') payload.surface = 'empty_state';
        pushEvent('view_' + key, payload);
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var key = el.getAttribute('data-sale-track-view');
        if (!key || seenViews.has(key)) return;
        seenViews.add(key);

        var payload = {};
        if (key === 'proof_strip') {
          payload.surface = 'proof_strip';
        } else if (key === 'empty_state') {
          payload.surface = 'empty_state';
        }

        pushEvent('view_' + key, payload);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });

    document.querySelectorAll('[data-sale-track-view]').forEach(function (el) {
      observer.observe(el);
    });
  }

  function observeProductImpressions() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-sale-product-card="true"]').forEach(function (card, index) {
        if (index >= impressionLimit) return;
        var meta = getCardMeta(card);
        var key = 'product_impression_' + meta.product_position + '_' + meta.product_handle;
        if (seenViews.has(key)) return;
        seenViews.add(key);
        pushEvent('product_impression', meta);
      });
      return;
    }
    var observedCount = 0;
    var impressionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var meta = getCardMeta(card);
        if (!meta.product_position || meta.product_position > impressionLimit) {
          impressionObserver.unobserve(card);
          return;
        }
        var key = 'product_impression_' + meta.product_position + '_' + meta.product_handle;
        if (seenViews.has(key)) {
          impressionObserver.unobserve(card);
          return;
        }
        seenViews.add(key);
        pushEvent('product_impression', meta);
        impressionObserver.unobserve(card);
      });
    }, { threshold: 0.55 });

    document.querySelectorAll('[data-sale-product-card="true"]').forEach(function (card) {
      var meta = getCardMeta(card);
      if (!meta.product_position || meta.product_position > impressionLimit) return;
      observedCount += 1;
      impressionObserver.observe(card);
    });
  }

  document.addEventListener('click', function (event) {
    var subcategory = event.target.closest('[data-sale-subcategory]');
    if (subcategory) {
      pushEvent('subcategory_click', {
        subcategory_name: subcategory.getAttribute('data-sale-subcategory') || '',
        subcategory_copy: subcategory.getAttribute('data-sale-subcategory-copy') || '',
        subcategory_surface: subcategory.getAttribute('data-sale-subcategory-surface') || '',
        destination_url: subcategory.getAttribute('href') || ''
      });
      return;
    }

    var emptyState = event.target.closest('[data-sale-empty-action]');
    if (emptyState) {
      pushEvent('empty_state_click', {
        empty_state_action: emptyState.getAttribute('data-sale-empty-action') || '',
        empty_state_label: emptyState.textContent.trim(),
        destination_url: emptyState.getAttribute('href') || ''
      });
      return;
    }

    var proof = event.target.closest('[data-sale-proof-action], [data-sale-proof-item]');
    if (proof && proof.tagName === 'A') {
      pushEvent('proof_strip_click', {
        proof_label: proof.getAttribute('data-sale-proof-item') || proof.textContent.trim(),
        proof_action: proof.getAttribute('data-sale-proof-action') || 'link',
        destination_url: proof.getAttribute('href') || ''
      });
      return;
    }

    var productLink = event.target.closest('a[data-sale-product-link]');
    if (productLink) {
      pushEvent('product_click', getCardMeta(productLink.closest('[data-sale-product-card="true"]')));
      return;
    }
  }, { passive: true });

  document.addEventListener('chagual:wa_expand', function (event) {
    pushEvent('whatsapp_expand', {
      whatsapp_context: event.detail && event.detail.context || '',
      whatsapp_label: event.detail && event.detail.label || ''
    });
  });

  document.addEventListener('chagual:wa_click', function (event) {
    pushEvent('whatsapp_click', {
      whatsapp_context: event.detail && event.detail.context || '',
      whatsapp_label: event.detail && event.detail.label || ''
    });
  });

  var mutationTimeout = 0;
  var observer = new MutationObserver(function () {
    if (mutationTimeout) window.clearTimeout(mutationTimeout);
    mutationTimeout = window.setTimeout(function () {
      observeViews();
      observeProductImpressions();
    }, 180);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  observeViews();
  observeProductImpressions();
})();
